var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layer", { staticClass: "opt_more_g", attrs: { name: "mode" } }, [
    _c("div", { staticClass: "box_opt_menu list_look_type" }, [
      _c("div", { staticClass: "menu_item" }, [
        _c(
          "a",
          {
            staticClass: "link_menu",
            attrs: { href: "javascript:" },
            on: {
              click: function ($event) {
                return _vm.callback("view")
              },
            },
          },
          [_vm._v("조회수")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu_item" }, [
        _c(
          "a",
          {
            staticClass: "link_menu",
            attrs: { href: "javascript:" },
            on: {
              click: function ($event) {
                return _vm.callback("cmt")
              },
            },
          },
          [_vm._v("댓글수")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }